var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wrapper-content"},[_c('v-row',[_c('v-col',[_c('div',{staticClass:"svg-container",attrs:{"id":"odontogramaFull"}}),_c('div',{staticClass:"tooltipDiv",attrs:{"id":"tooltipId"}},[_c('span',{attrs:{"id":"tooltipSpan"}})])])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }